import { render, staticRenderFns } from "./KETKontaktliste.vue?vue&type=template&id=56f734ba&"
import script from "./KETKontaktliste.vue?vue&type=script&lang=js&"
export * from "./KETKontaktliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports